import React from 'react';
import { FaTimes, FaFilePdf, FaDownload, FaBook } from 'react-icons/fa';
import './DocumentsModal.css';
import API_BASE_URL from '../../config/api';

// Returns the documents list based on the user type
const getDocuments = (userType, userId) => {
    const type = (userType || '').toLowerCase();

    const manualByType = {
        atleta: {
            name: 'Manual do Atleta',
            description: 'Guia completo para atletas — regras, treinos, calendário e mais.',
            url: '/manual-atleta.pdf',
            fileName: 'Manual_Atleta.pdf',
            size: '5.1 MB',
        },
        treinador: {
            name: 'Manual do Treinador',
            description: 'Guia completo para treinadores — gestão de equipa, presenças e eventos.',
            url: '/manual-treinador.pdf',
            fileName: 'Manual_Treinador.pdf',
            size: '6.8 MB',
        },
        socio: {
            name: 'Manual do Sócio',
            description: 'Guia completo para sócios — benefícios, pagamentos e serviços.',
            url: '/manual-socio.pdf',
            fileName: 'Manual_Socio.pdf',
            size: '4.4 MB',
        },
    };

    // Pick the right manual — fall back to socio
    const manual = manualByType[type] || manualByType.socio;

    const docs = [
        {
            name: manual.name,
            description: manual.description,
            type: 'PDF',
            size: manual.size,
            url: manual.url,
            fileName: manual.fileName,
            isManual: true,
        },
    ];

    // Membership card only for socio / atleta (not treinador-only)
    if (type !== 'treinador') {
        docs.unshift({
            name: 'Cartão de Sócio',
            description: 'Cartão digital de identificação de sócio.',
            type: 'PDF',
            size: '156 KB',
            isMembershipCard: true,
        });
    }

    return docs;
};

const DocumentsModal = ({ isOpen, onClose, userId, userType }) => {
    if (!isOpen) return null;

    const documents = getDocuments(userType, userId);

    const handleDownload = async (doc) => {
        if (doc.locked) return;

        const token = localStorage.getItem('token');

        if (doc.isMembershipCard) {
            try {
                const response = await fetch(`${API_BASE_URL}/api/membershipcard/download?userId=${userId}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
                });
                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `Cartao_Socio_${userId}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                } else {
                    alert('Erro ao gerar cartão. Verifique se é um sócio ativo.');
                }
            } catch (err) {
                console.error('Download failed', err);
            }
            return;
        }

        // Static PDF — open in new tab and trigger download
        const a = document.createElement('a');
        a.href = doc.url;
        a.target = '_blank';
        a.download = doc.fileName || doc.name.replace(/\s+/g, '_') + '.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    return (
        <div className="doc-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className="doc-modal">
                <div className="doc-modal-header">
                    <h2>Centro de Documentação</h2>
                    <button className="doc-modal-close" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="doc-modal-body">
                    <p className="doc-intro">Aqui pode consultar e descarregar todos os documentos oficiais relativos à sua conta e ao clube.</p>

                    <div className="doc-list">
                        {documents.map((doc, index) => (
                            <div key={index} className={`doc-card ${doc.locked ? 'doc-locked' : ''}`}>
                                <div className="doc-icon">
                                    {doc.isManual ? <FaBook /> : <FaFilePdf />}
                                </div>
                                <div className="doc-info">
                                    <h3>{doc.name}</h3>
                                    <p>{doc.description}</p>
                                    <span className="doc-meta">{doc.type} • {doc.size}</span>
                                </div>
                                <div className="doc-actions">
                                    {doc.locked ? (
                                        <span className="doc-lock-badge">Brevemente</span>
                                    ) : (
                                        <button className="doc-download-btn" onClick={() => handleDownload(doc)}>
                                            <FaDownload /> Descarregar
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentsModal;
